import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

const initialState = {
  showFilter: false,
  applied: undefined,
  current: undefined,
};

class ColumnFilter extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  setCurrent = (current) => {
    this.setState({
      current,
    });
  };

  applyFilter = () => {
    this.setState((prevState) => ({
      showFilter: false,
      applied: prevState.current,
    }));
    this.props.onChange(this.state.current);
  };

  cancelFilter = () => {
    this.setState((prevState) => ({
      showFilter: false,
      current: prevState.applied,
    }));
  };

  clearFilter = () => {
    this.setState(initialState);
    this.props.onChange({
      clearFilter: true,
    });
  };

  showFilter = () => {
    this.setState({
      showFilter: true,
    });
  };

  isValid = () => this.state.current && this.state.current.valid;

  renderHiddenFilter = () => (
    <button
      type="button"
      className={`advanced-filter__toggle ${this.state.applied
        ? 'active'
        : 'inactive'}`}
      onClick={this.showFilter}
    >
      <FormattedMessage id="filter-component.action.filter" />
    </button>
  );

  renderFilter = () => (
    <div className="advanced-filter__selection number">
      <h4 className="advanced-filter__title">{this.props.column.Header}</h4>

      {this.props.render(this.state.current, this.setCurrent)}

      <button
        disabled={!this.isValid()}
        type="button"
        className="advanced-filter__toggle apply"
        onClick={this.applyFilter}
      >
        <FormattedMessage id="filter-component.action.apply" />
      </button>
      <button
        type="button"
        className="advanced-filter__toggle remove"
        onClick={this.clearFilter}
      >
        <FormattedMessage id="filter-component.action.clear-filter" />
      </button>
      <button
        type="button"
        className="advanced-filter__toggle cancel"
        onClick={this.cancelFilter}
      >
        <FormattedMessage id="filter-component.action.cancel" />
      </button>
    </div>
  );

  render() {
    return (
      <div className="advanced-filter">
        {this.state.showFilter ? this.renderFilter() : this.renderHiddenFilter()}
      </div>
    );
  }
}

ColumnFilter.propTypes = {
  onChange: PropTypes.func,
  column: PropTypes.shape({
    Header: PropTypes.string,
    id: PropTypes.string,
    accessor: PropTypes.func,
  }),
  render: PropTypes.func,
};

export default ColumnFilter;
